import React from 'react';
import * as Sentry from '@sentry/react';

interface ErrorPageProps {
  statusCode?: number;
  errorPage?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ statusCode = 500 }) => {
  React.useEffect(() => {
    if (statusCode >= 500) {
      Sentry.captureException(new window.Error(`Error ${statusCode}`));
    }
  }, [statusCode]);

  return (
    <div style={{ position: 'relative', padding: '40px', textAlign: 'center' }}>
      <h1>{statusCode}</h1>
      <p>{statusCode === 404 ? 'This page could not be found.' : 'An error occurred on the server.'}</p>
    </div>
  );
};

export default ErrorPage;
